function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopcorn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF7E6"
    },
    d: "M384.521,98.148L384.521,98.148L384.521,98.148c23.865-27.674-11.275-66.701-41.291-45.859l0,0l0,0  c10.546-34.988-37.429-56.348-56.374-25.099l0,0l0,0c-4.596-36.253-57.112-36.253-61.709,0l0,0l0,0  c-18.944-31.249-66.921-9.889-56.374,25.099l0,0l0,0c-30.018-20.842-65.158,18.185-41.293,45.859l0,0l0,0  c-35.898-6.832-52.127,43.115-19.069,58.689l0,0v23.838H403.59v-23.838l0,0C436.648,141.263,420.419,91.316,384.521,98.148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2CC7B"
    },
    d: "M348.818,129.756c-4.925,0-8.961-3.948-9.05-8.892c-0.105-5.919-2.583-11.36-6.975-15.323  c-4.193-3.782-9.613-5.703-15.244-5.414c-5.638,0.29-10.826,2.758-14.608,6.951c-2.892,3.206-7.646,3.925-11.356,1.714  c-3.71-2.21-5.343-6.733-3.9-10.802c1.398-3.945,1.176-8.197-0.625-11.975c-1.801-3.779-4.965-6.627-8.91-8.025  c-8.144-2.885-17.116,1.392-20.001,9.536c-1.67,4.713-6.846,7.18-11.558,5.51c-4.713-1.67-7.18-6.845-5.51-11.558  c6.219-17.555,25.56-26.776,43.116-20.556c8.503,3.013,15.325,9.158,19.208,17.3c0.926,1.942,1.659,3.943,2.196,5.978  c3.504-1.228,7.206-1.96,11.018-2.157c10.474-0.54,20.521,3.031,28.304,10.052c8.037,7.25,12.759,17.618,12.952,28.444  c0.089,4.999-3.891,9.125-8.891,9.215C348.928,129.756,348.873,129.756,348.818,129.756z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFF7E6"
    },
    points: "170.677,180.675 177.21,204.515 163.166,216.741 186.02,498.737 198.934,512 370.773,512   419.09,180.675 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#FF6465"
    },
    points: "256.001,204.515 256.001,512 313.067,512 334.792,204.515 316.703,181.544    270.135,181.544 256.001,204.515  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF6465"
    },
    points: "170.677,180.675 92.911,180.675 141.227,512 198.934,512 177.21,204.515  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    points: "92.911,180.675 100.788,234.695 411.213,234.695 419.09,180.675   170.677,180.675 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2CC7B"
    },
    d: "M412.23,156.837H99.772c-13.166,0-23.838,10.673-23.838,23.838l0,0  c0,13.166,10.673,23.838,23.838,23.838h312.457c13.166,0,23.839-10.673,23.839-23.838l0,0  C436.068,167.509,425.395,156.837,412.23,156.837z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopcorn);
export default __webpack_public_path__ + "static/media/popcorn.3d0fde688e76933c106e2bb0d32b1409.svg";
export { ForwardRef as ReactComponent };